import { createHTTPClient } from './client';
import { env } from '$env/dynamic/public';

export default createHTTPClient({
	baseURL: env.PUBLIC_SHOP_API_BASE_URL,
	handleClientError: true,
	logoutWhenUnauthorized: true,
	requestLoginWhenUnauthorized: true
});
